import { useContext, type ReactNode } from "react";
import { WeltKontext } from "./kontext";

/** W82 Teil 3 (auftrag-w82-web-3 Punkt 1): Wurzel einer Seite der W82-Welt. Setzt `data-welt="wurzel"` (Grund, Schrift,
 *  W82-Gestalt der Bestandsbausteine, welt.css) und stellt `useWeltAktiv()` bereit; Blätter, Rückfragen und der Hinweis
 *  der App lesen den Kontext und tragen `data-welt` an ihrem Portal-Inhalt, der außerhalb der Wurzel hängt. */
export function WeltWurzel(props: { kennung?: string; className?: string; children: ReactNode }) {
  return (
    <WeltKontext.Provider value={true}>
      <div data-welt="wurzel" data-testid={props.kennung} className={props.className}>
        {props.children}
      </div>
    </WeltKontext.Provider>
  );
}

/** Ob der Baustein unter einer `WeltWurzel` steht (Portale tragen dann selbst `data-welt`). */
export function useWeltAktiv(): boolean {
  return useContext(WeltKontext);
}
